export const API_ENDPOINTS = {
    SLUG: "/pages",
    FORM: "/form",
    location: "/verify-location",
    media: "/upload-file-form",
    SEARCH: "/search-form",
    SITEMAP: "/sitexml",
};
